module.exports = __webpack_public_path__ + "static/media/CREATIVIDAD_INNOVACION_EMPRENDIMIENTO.66543b1e.png";